import React from 'react';
import { TextInput } from './FormComponents';

const AccountUserInfo = ({ formData, handleChange,errorData,handleBlur }) => (

    <div className="">
      <div className="row">
        <div className="col-md-6">
          <TextInput
            label="Name of Account User"
            name="accountUserName"
            id="accountUserName"
            value={formData.accountUserName}
            onChange={handleChange}
            required
            errorData={errorData.accountUserName}
         handleBlur={handleBlur} 
          />
        </div>
        <div className="col-md-6">
          <TextInput
            label="Designation of Account User"
            name="accountUserDesignation"
            id="accountUserDesignation"
            value={formData.accountUserDesignation}
            onChange={handleChange}
            required
            errorData={errorData.accountUserDesignation}
          handleBlur={handleBlur}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <TextInput
            label="Mobile No. of Account User"
            name="accountUserMobile"
            id="accountUserMobile"
            value={formData.accountUserMobile}
            onChange={handleChange}
            required
            type="tel"
            errorData={errorData.accountUserMobile}
          handleBlur={handleBlur}
          />
        </div>
        <div className="col-md-6">
          <TextInput
            label="Email Address of Account User"
            name="accountUserEmail"
            id="accountUserEmail"
            value={formData.accountUserEmail}
            onChange={handleChange}
            required
            type="email"
            errorData={errorData.accountUserEmail}
            handleBlur={handleBlur}
            
          />
        </div>
      </div>
    </div>
);

export default AccountUserInfo;